/* NOMO 05-10: bundle pricing follows the two automatic discounts in Shopify, so the page, the cart and the
   checkout always show the same amount:
     - "NOMO Duo":    EUR 20,00 off the Keychain Totes at 2 or more bags
     - "NOMO Family": EUR 60,38 off at 4 or more bags
   Change a discount in Shopify? Then change the matching amount (in cents) below as well. */
(function () {
  var DUO = 2000, FAMILY = 6038;
  var apply = function () {
    var El = customElements.get('nomo-product');
    if (!El || El.prototype.__nomo0510) return false;
    El.prototype.__nomo0510 = true;
    El.prototype.giftTotal = function (items) {
      var sum = items.reduce(function (t, v) { return t + Number((v && v.price) || 0); }, 0);
      var off = items.length >= 4 ? FAMILY : items.length >= 2 ? DUO : 0;
      return Math.max(0, sum - off);
    };
    document.querySelectorAll('nomo-product').forEach(function (el) {
      el.dataset.checkoutReady = 'true';
      if (typeof el.refreshBundleAvailability === 'function') { try { el.refreshBundleAvailability(); } catch (e) {} }
    });
    return true;
  };
  if (!apply()) customElements.whenDefined('nomo-product').then(apply);
})();

/* 05-10: "Bestseller" badge top-left on the product photo (text in theme editor > Teksten productpagina > Badge). */
(function () {
  var run = function () {
    var node = document.getElementById('nomo-hero-texts');
    var T = {}; try { T = JSON.parse(node ? node.textContent : '{}') || {}; } catch (e) {}
    var text = (T.badge == null ? 'Bestseller' : String(T.badge)).trim();
    var stage = document.querySelector('.product-gallery .gallery-stage');
    if (!text || !stage || stage.querySelector('.nb-bestseller')) return;
    var b = document.createElement('span');
    b.className = 'nb-bestseller';
    b.textContent = text;
    stage.appendChild(b);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* 05-10: (a) three trust badges under the buy button (hidden since 06-10, replaced by nomo-0610.js),
   (b) "bijna uitverkocht" note inside each bag's colour card for the chosen size + colour ("Bijna uitverkocht per tas").
   06-10: no percentages or bars any more; every Limited (Polka-dot) colour always shows the note. */
(function () {
  var T = {};
  var read = function () { var n = document.getElementById('nomo-hero-texts'); try { T = JSON.parse(n ? n.textContent : '{}') || {}; } catch (e) { T = {}; } };
  var ICONS = [
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.3-5.7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M4 4v4.5h4.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h10v9H3zM13 10h4l3 3v3h-7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="7" cy="17.5" r="1.8" fill="currentColor"/><circle cx="17" cy="17.5" r="1.8" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.4-7-9.5A3.8 3.8 0 0 1 12 8a3.8 3.8 0 0 1 7 2.5C19 15.6 12 20 12 20z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>'
  ];
  var badges = function () {
    var ship = document.querySelector('.nb-ship');
    if (!ship || document.querySelector('.nb-badges')) return;
    var texts = String(T.atcBadges || '30 dagen retour | Gratis verzending | 10.000+ tevreden klanten').split('|').map(function (t) { return t.trim(); }).filter(Boolean).slice(0, 3);
    var row = document.createElement('div');
    row.className = 'nb-badges';
    texts.forEach(function (t, i) {
      var b = document.createElement('span');
      b.className = 'nb-badge';
      b.innerHTML = (ICONS[i] || '') + '<span>' + t.replace(/[<>&]/g, '') + '</span>';
      row.appendChild(b);
    });
    ship.insertAdjacentElement('afterend', row);
  };
  var stockMap = function () {
    var map = {};
    String(T.stockMap || '').split(/\r?\n/).forEach(function (line) {
      var m = line.match(/^\s*(small|large)\s+(.+?)\s*[:=]\s*(.+?)\s*$/i);
      if (m) map[m[1].toLowerCase() + '|' + m[2].toLowerCase()] = m[3].toLowerCase();
    });
    return map;
  };
  var checked = function (pick, sel) { var i = pick.querySelector(sel + ':checked'); return i ? i.value : ''; };
  var lowStock = function () {
    var map = stockMap();
    document.querySelectorAll('.nb-pick').forEach(function (pick) {
      var size = checked(pick, '[data-pick-size]') || 'Small', colour = checked(pick, '[data-pick-color]');
      var v = map[(size + '|' + colour).toLowerCase()];
      if (!v && /polka/i.test(colour)) v = 'bijna';
      var low = pick.querySelector('.nb-low');
      if (!colour || !v || /voorraad|op$/.test(v)) { if (low) low.remove(); return; }
      if (!low) { low = document.createElement('div'); low.className = 'nb-low'; pick.appendChild(low); }
      low.innerHTML = '<p class="nb-low__txt"><b>' + colour.replace(/[<>&]/g, '') + '</b> is bijna uitverkocht</p>';
    });
  };
  var run = function () {
    read(); badges(); lowStock();
    document.querySelectorAll('nomo-product').forEach(function (el) {
      el.addEventListener('change', function () { setTimeout(lowStock, 0); });
      el.addEventListener('click', function () { setTimeout(lowStock, 0); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
